module.exports = __webpack_public_path__ + "img/4.81a22e2c.jpg";